var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0826 38.6953C28.9206 40.1101 30.6269 40.407 31.8936 39.3586C33.1604 38.3101 33.5079 36.3133 32.6698 34.8985L25.7932 23.2897H36.6902C38.5182 23.2897 40 21.8079 40 19.98C40 18.152 38.5182 16.6702 36.6902 16.6702H25.56L32.4129 5.10148C33.2509 3.68672 32.9034 1.68989 31.6367 0.641429C30.3699 -0.407028 28.6637 -0.110082 27.8256 1.30468L20.2978 14.0127L12.7616 1.29046C11.9236 -0.124301 10.2173 -0.421249 8.95057 0.627208C7.68383 1.67567 7.33632 3.6725 8.17437 5.08726L15.0357 16.6702H3.30976C1.48183 16.6702 0 18.152 0 19.98C0 21.8079 1.48183 23.2897 3.30976 23.2897H14.8025L7.91743 34.9128C7.07938 36.3275 7.42689 38.3243 8.69363 39.3728C9.96036 40.4213 11.6666 40.1243 12.5047 38.7095L20.2978 25.5535L28.0826 38.6953Z",
    fill: "#C8AA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAll);
export default __webpack_public_path__ + "static/media/Icon_All.697d1c6378983a227203d0b2082c356f.svg";
export { ForwardRef as ReactComponent };